/* eslint-disable react/display-name */
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { useBarcode } from 'react-barcodes'
import { Typography } from '@material-ui/core'
import { get, size } from 'lodash'
import moment from 'moment'

import printTicketStyles from './css/printTicketStyles'

const PrintTicket = forwardRef((props, ref) => {
  const classes = printTicketStyles()
  const { ticketData, skuList } = props
  const formatDate = moment(get(ticketData, 'fecha') || '', 'YYYY-MM-DD').format('DD/MM/YYYY')
  const barcodeDate = moment(get(ticketData, 'fecha') || '', 'YYYY-MM-DD').format('DDMMYY')
  const barcodeString = `${barcodeDate}${get(ticketData, 'sucursal') || ''}${
    get(ticketData, 'caja') || ''
  }${get(ticketData, 'numeroTrx') || ''}`

  const { inputRef } = useBarcode({
    value: barcodeString,
    options: {
      background: '#ffffff',
      width: 1,
      height: 50,
      font: 'Montserrat, sans-serif',
      fontSize: 12,
    },
  })

  return (
    <div ref={ref} className={classes.root}>
      <Typography variant="body2" align="center">
        TICKET DE REGALO
      </Typography>
      <Typography variant="caption" align="center">
        Para cambio o servicio técnico, debe presentar este documento
      </Typography>

      <Typography variant="caption" align="center" className={classes.textMarginTop}>
        COMERCIO/SUCURSAL: {get(ticketData, 'sucursalCom') || ''}
      </Typography>
      <Typography variant="caption" align="center">
        {get(ticketData, 'sucursal') || ''}/{get(ticketData, 'caja') || ''} {formatDate}{' '}
        {get(ticketData, 'numeroTrx') || ''}
      </Typography>

      <Typography variant="caption" align="center" className={classes.textMarginTop}>
        BOLETA REFERENCIA: {get(ticketData, 'boleta') || ''}
      </Typography>

      <svg ref={inputRef} />

      <Typography variant="caption" align="center">
        Ripley
      </Typography>
      <Typography variant="caption" align="center">
        NRO. DE UNIDADES: {size(skuList)}
      </Typography>

      <div className={classes.textMarginTop}>
        {skuList.map((row, index) => {
          const textKey = `text-key-${get(row, 'id')}-${index}`

          return (
            <Typography key={textKey} component="div" variant="caption" align="center">
              {get(row, 'id')}
            </Typography>
          )
        })}
      </div>
    </div>
  )
})

PrintTicket.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  ticketData: PropTypes.object,
  skuList: PropTypes.arrayOf(PropTypes.string),
}

PrintTicket.defaultProps = {
  ticketData: {},
  skuList: '',
}

export default PrintTicket
